import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { mq } from '../../../../styles/mixins';

export const ProcessItemWrapper = styled.div`
  min-width: 13.425rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 1rem;
`;

export const ItemDescription = styled.p`
  font-family: ${({ theme }) => theme.font.nunito};
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.5rem;
  letter-spacing: 0.0125rem;
  color: ${({ theme }) => theme.colors.core_black};
  margin: 0;
`;

export const Divider = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin: 1.0625rem 0;

  ${mq.large(css`
    margin-top: 1rem;
    margin-bottom: 0;
  `)};

  svg {
    transform: rotate(90deg);

    ${mq.large(css`
      transform: rotate(0deg);
    `)};
  }
`;
